export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4643.9939d00f.jpg";